<template>
	<div v-if="supplementaryHeatersProp.length || valveGroups.length" class="valve-picker">
		<h3 class="heading">Select heater &amp; valves</h3>

		<div v-if="supplementaryHeatersProp.length" class="valve-type">
			<h5  @click="toggleSupplementaryHeaterOpen()" class="valve-type-heading">Supplementary Heater</h5>
			<div :class="{'hidden': !supplementaryHeaterOpen}" class="options">
				<div v-for="supplementaryHeaterProp in supplementaryHeatersProp" :key="supplementaryHeaterProp.id" class="item">
					<label class="label"><input @change="toggleSupplementaryHeaterSelected(supplementaryHeaterProp)" :checked="supplementaryHeaterSelectedProp && supplementaryHeaterSelectedProp.id == supplementaryHeaterProp.id" type="checkbox" name="heater" value="0"> <span class="title">{{ supplementaryHeaterProp.title }}</span></label>
				</div>
			</div>
		</div>

		<div v-for="valveGroup in valveGroups" :key="valveGroup.handle">
			<ValveGroup :valveGroupProp="valveGroup" :valveGroupOpenProp="valveGroupOpen" :valveSelectedProp="valveSelectedProp" :suppHeaderSelectedProp="supplementaryHeater" @valveGroupOpen="onValveGroupOpened" @valveSelected="onValveSelected" />
		</div>

	</div>
</template>

<script>
	import ValveGroup from './ValveGroup.vue';

	export default {
		props: ['supplementaryHeatersProp', 'supplementaryHeaterSelectedProp', 'valveGroups', 'valveSelectedProp'],
		data() {
			return {
				supplementaryHeaterOpen: false,
				supplementaryHeater: false,
				valveGroupOpen: null,
				valveSelected: null,
			};
		},
		components: {
			ValveGroup,
		},
		mounted: function() {
			this.supplementaryHeater = this.supplementaryHeaterSelectedProp;
		},
		methods: {
			toggleSupplementaryHeaterOpen: function() {
				this.supplementaryHeaterOpen = !this.supplementaryHeaterOpen;
			},
			toggleSupplementaryHeaterSelected: function(supplementaryHeater) {
				this.supplementaryHeater = this.supplementaryHeater == supplementaryHeater ? null : supplementaryHeater;
				this.$emit('supplementaryHeaterSelected', this.supplementaryHeater);
			},
			onValveSelected: function(valve) {
				this.valveSelected = valve;
				this.$emit('valveSelected', this.valveSelected);
			},
			onValveGroupOpened: function(valveGroup) {
				this.valveGroupOpen = valveGroup;
			},
		}
	};
</script>

<style scoped>
	.valve-picker {
		border-top: 1px solid #2B2012;
	}

	.heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 10px 0;
	}

	.valve-type {
		padding: 13px 9px;
		margin: 0 0 9px;
		background-color: #eee;
	}

	.valve-type-heading {
		cursor: pointer;
		font-size: 12px;
		margin: 0;
	}

	.options {
		color: #333;
		font: 14px/1.5 "Lora",serif;
		margin: 9px 0 0;
	}

	.title {
		color: #333;
		font-size: 14px;
		line-height: 1.5;
		font-family: Arial, serif;
	}

	.hidden {
		display: none;
	}
</style>